import {
  DatasetResult,
  DataViewTypes,
  ExportedDatasetSourceContent,
  ProducerType,
  ProducerTypes,
  SwitchViewDomain,
} from '@mode/shared/contract-common';
import { Observable } from 'rxjs';
import { Dataset } from './dataset-types';
import { HttpErrorResponse } from '@angular/common/http';

export abstract class DatasetFacade {
  abstract deleted$: Observable<boolean>;
  abstract dataset$: Observable<Dataset>;
  abstract datasetType$: Observable<ProducerTypes>;
  abstract datasetImportCount$: Observable<number>;
  abstract datasetName$: Observable<string>;
  abstract isSheetDataset$: Observable<boolean>;
  abstract isNotebookCellDataset$: Observable<boolean>;
  abstract isDatasetPublished$: Observable<boolean>;
  abstract loadDatasetError$: Observable<HttpErrorResponse | null>;
  abstract exportedDatasetSource$: Observable<ExportedDatasetSourceContent>;
  abstract datasetDeletedFromCollectionToken$: any;
  abstract loadDatasetEditRoute(datasetToken: string): void;
  abstract loadDatasetViewRoute(datasetToken: string): void;
  abstract deleteDataset(datasetToken: string): void;
  abstract removePhantomDataset(accountId: string, reportId: string, switchViewToken: string): void;
  abstract googleSheetSyncCompleted({ dataView }: { dataView: SwitchViewDomain.DataView }): void;
  abstract runDatasetPollingCompleted({ dataView }: { dataView: SwitchViewDomain.DataView }): void;
  abstract openDeleteDatasetModal(token: string): void;
  abstract openDeleteDatasetModalFromCollectionList(token: string): void;
  abstract openDeleteDatasetModalFromCollectionTile(token: string): void;
  abstract openDeleteDatasetModalFromCollectionSidePanel(token: string): void;
  abstract deleteFromCollection(token: string): void;
  /* TODO: add the missing return type */
  abstract loadImportedDataset(switchViewToken: string): any;
  abstract getSheetMetadata(dataset: DatasetResult): DataViewTypes.GoogleSheetMetadata | null;
  /* TODO: add the missing return type */
  abstract isSheetDataset(datasetProducerType: ProducerType): any;
  abstract isNotebookCellDataset(datasetProducerType: ProducerType): boolean;
  abstract openPublishDatasetModal(switchViewToken: string): void;
  abstract openRepublishDatasetModal(switchViewToken: string): void;
  abstract openUnpublishDatasetModal(switchViewToken: string): void;
  abstract publishDataset(
    datasetToken: string,
    name: string,
    producerType: ProducerType,
    queryToken?: string,
    switchViewToken?: string
  ): void;
  abstract republishDataset(datasetThoughtspotPublicationToken: string): void;
  abstract unpublishDataset(
    datasetToken: string,
    producerType: ProducerType,
    switchViewToken: string,
    datasetThoughtspotPublicationToken: string
  ): void;
  abstract hasCalcFields(dataset: Dataset): boolean;
  abstract loadExportedDatasetSource(queryToken: string): void;
}
